import { getJson } from "../../../api";
import { AssetInventoryDto } from "../../../backoffice/api";
import { DeskInventoryFiltersGroupedByType } from "../domain";

export interface DeskAssetInventoryDto {
  assetInventory: AssetInventoryDto;
  quantityOnDesk: number;
}

export async function getLocationInventories(
  organizationId: string,
  locationId: string | undefined
): Promise<DeskInventoryFiltersGroupedByType[]> {
  const response = await getJson<DeskInventoryFiltersGroupedByType[]>(
    `/api/desk-inventories/locations/${locationId}`,
    {
      "filter.organization.id": organizationId,
    }
  );
  return response;
}
